export const FIELD_MAPPINGS = {
  period: 'periodName',
  type: 'type',
  allowtopside: 'allowTopside',
  activity: 'activity',
  slview: 'slView',
  allowentry: 'allowEntry',
  allowtransfer: 'allowTransfer',
};

export const MIN_COLUMNS_NUMBER = 7;
export const MAX_COLUMNS_NUMBER = 7;
